import { lazy } from "react";
import { QueryClient } from "@tanstack/react-query";
import { AppShell } from "@/components/layout/app-shell";
import { AuthGuard } from "@/components/auth-guard";
import { RuntimeApp, type AppRuntime } from "@/app/runtime-app";
import { useGetMe } from "@workspace/api-client-react";

const LandingPage = lazy(() => import("@/pages/landing"));
const LoginPage = lazy(() => import("@/pages/login"));
const RegisterPage = lazy(() => import("@/pages/register"));
const AdminLoginPage = lazy(() => import("@/pages/admin/login"));
const AdminPage = lazy(() => import("@/pages/admin/index"));
const SubscriptionPage = lazy(() => import("@/pages/subscription"));

const queryClient = new QueryClient();

const webRuntime: AppRuntime = {
  Shell: AppShell,
  AuthBoundary: AuthGuard,
  RootPage: LandingPage,
  LoginPage,
  RegisterPage,
  AdminLoginPage,
  AdminPage,
  SubscriptionPage,
  activity: {
    useSession: () => {
      const { data } = useGetMe();
      return { key: data ? `web:${data.id}` : null };
    },
  },
};

function App() {
  return <RuntimeApp runtime={webRuntime} queryClient={queryClient} />;
}

export default App;
